import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch, useSelector } from 'react-redux';

import * as chanceApi from '../../lib/api/chance';
import ProjectForm from '../../components/chancemng/ProjectForm';

const ProjectFormContainer = ({ type }) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { chance } = useSelector(({ chanceModule }) => ({
    chance: chanceModule.chance.chance,
  }));

  let initialValues = {
    cstNm:
      chance && chance.cstNm !== null && chance.cstNm !== undefined
        ? chance.cstNm
        : '',
    partnerInc:
      chance && chance.partnerInc !== null && chance.partnerInc !== undefined
        ? chance.partnerInc
        : '',
    prjTyp:
      chance && chance.prjTyp !== null && chance.prjTyp !== undefined
        ? chance.prjTyp
        : '',
    incTyp:
      chance && chance.incTyp !== null && chance.incTyp !== undefined
        ? chance.incTyp
        : '',
    solutionTyp:
      chance && chance.solutionTyp !== null && chance.solutionTyp !== undefined
        ? chance.solutionTyp
        : '',
    chanceTyp:
      chance && chance.chanceTyp !== null && chance.chanceTyp !== undefined
        ? chance.chanceTyp
        : '',
    prjImpt:
      chance && chance.prjImpt !== null && chance.prjImpt !== undefined
        ? chance.prjImpt
        : '',
    bugetYn:
      chance && chance.bugetYn !== null && chance.bugetYn !== undefined
        ? chance.bugetYn
        : '',
    // partnerTyp:
    //   chance && chance.partnerTyp !== null && chance.partnerTyp !== undefined
    //     ? chance.partnerTyp
    //     : '',
    // 2026-10-19 (ksm_frontend에서 포팅, 요구사항 5/02): 고객사 UUID·담당자 UUID -
    // 고객명을 텍스트로만 저장하지 않고 거래처/담당자를 실제로 연결하기 위함.
    customerUuid:
      chance && chance.customerUuid !== null && chance.customerUuid !== undefined
        ? chance.customerUuid
        : '',
    vendorCmp:
      chance && chance.vendorCmp !== null && chance.vendorCmp !== undefined
        ? chance.vendorCmp
        : '',
    vendorEmp:
      chance && chance.vendorEmp !== null && chance.vendorEmp !== undefined
        ? chance.vendorEmp
        : '',
    chargeNm:
      chance && chance.chargeNm !== null && chance.chargeNm !== undefined
        ? chance.chargeNm
        : '',
    chargeEml:
      chance && chance.chargeEml !== null && chance.chargeEml !== undefined
        ? chance.chargeEml
        : '',
    chargeTel:
      chance && chance.chargeTel !== null && chance.chargeTel !== undefined
        ? chance.chargeTel
        : '',
    forcastTxt:
      chance && chance.forcastTxt !== null && chance.forcastTxt !== undefined
        ? chance.forcastTxt
        : '',
  };



  let validationSchema = yup.object({
    cstNm: yup.string('').required('사업명을 입력하세요'),
    prjTyp: yup.string().required('프로젝트 종류를 선택하세요'),
    partnerInc: yup.string().required('고객명을 입력하세요'),
    // 거래처 유형(incTyp) 필드는 화면에서 제거됨(0425 p22/0515 p33) - 필수 해제, DB 컬럼은 유지
    incTyp: yup.string().nullable(),
    solutionTyp: yup.string().nullable('아이템 구분을 선택하세요'),
    chanceTyp: yup.string().required('기회유형을 선택하세요'),
    prjImpt: yup.string().required('프로젝트 중요도를 선택하세요'),
    bugetYn: yup.string().required('예산여부를 선택하세요'),
    // partnerTyp: yup.string().required('거래처유형을 선택하세요'),
    chargeNm: yup.string().required('고객 담당자를 입력하세요'),
    chargeEml: yup.string('').email('이메일 형식을 확인하세요').nullable(),
    chargeTel: yup.string().nullable(),
    forcastTxt: yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      
      setSubmitting(true);
      onSave(type, values);
      formik.resetForm();
      setSubmitting(false);
    },
  });



  const onSave = async (type, values) => {
    let dataToSubmit = {
      partnerInc: values.partnerInc,
      cstNm: values.cstNm,
      prjTyp: values.prjTyp,
      incTyp: values.incTyp,
      solutionTyp: values.solutionTyp,
      chanceTyp: values.chanceTyp,
      prjImpt: values.prjImpt,
      bugetYn: values.bugetYn,
      //partnerTyp: values.partnerTyp,
      customerUuid: values.customerUuid,
      vendorCmp: values.vendorCmp || values.customerUuid,
      vendorEmp: values.vendorEmp,
      chargeNm: values.chargeNm,
      chargeEml: values.chargeEml,
      chargeTel: values.chargeTel,
      forcastTxt: values.forcastTxt,
    };


    if (type === 'add') {
      dataToSubmit.cstGrade = 1;
      dataToSubmit.cstStatus = '기회확인';



      try {
        const res = await chanceApi.addChance(dataToSubmit);
        if (res.data) {
          //console.log(res.data.info,'res.data.info');
          navigate(`/chancemng/${res.data.info.prjUuid}/1/1`);
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    }
  };

  return <ProjectForm type={type} formik={formik} />;

}

export default ProjectFormContainer
